
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  surname: 'surname',
  email: 'email',
  emailHash: 'emailHash',
  personalEmail: 'personalEmail',
  personalEmailHash: 'personalEmailHash',
  role: 'role',
  slackUserId: 'slackUserId',
  schedulerInformationId: 'schedulerInformationId',
  chatId: 'chatId',
  organisationId: 'organisationId',
  contactDetailsId: 'contactDetailsId',
  dateOfBirth: 'dateOfBirth',
  emergencyContactDetailsId: 'emergencyContactDetailsId',
  gender: 'gender',
  generalPracticionerContactDetailsId: 'generalPracticionerContactDetailsId',
  languages: 'languages',
  clinicalProfileId: 'clinicalProfileId',
  status: 'status',
  hasEnrolledMfa: 'hasEnrolledMfa',
  phone: 'phone',
  city: 'city',
  country: 'country',
  marketingOptIn: 'marketingOptIn',
  preferredLanguage: 'preferredLanguage',
  timezone: 'timezone',
  suspendedAt: 'suspendedAt',
  slackIntegrationId: 'slackIntegrationId',
  ageGroup: 'ageGroup',
  ethnicity: 'ethnicity',
  religion: 'religion',
  personalIdNumber: 'personalIdNumber',
  sexualOrientation: 'sexualOrientation',
  region: 'region',
  apartment: 'apartment',
  streetAddress: 'streetAddress',
  zipCode: 'zipCode',
  paymentDisclaimerAcceptedAt: 'paymentDisclaimerAcceptedAt',
  paymentServiceCustomerId: 'paymentServiceCustomerId',
  paymentServicePaymentMethodId: 'paymentServicePaymentMethodId',
  organisationTeam: 'organisationTeam'
};

exports.Prisma.RelationLoadStrategy = {
  query: 'query',
  join: 'join'
};

exports.Prisma.InsuranceInformationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  planName: 'planName',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  address: 'address',
  phone: 'phone',
  idNumber: 'idNumber',
  relation: 'relation',
  insuredName: 'insuredName',
  insuredSurname: 'insuredSurname',
  insuredCity: 'insuredCity',
  insuredState: 'insuredState',
  insuredZipCode: 'insuredZipCode',
  insuredAddress: 'insuredAddress',
  insuredPhone: 'insuredPhone',
  identifyingSex: 'identifyingSex',
  additionalPlans: 'additionalPlans'
};

exports.Prisma.InsuranceClaimScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  insuranceInformationId: 'insuranceInformationId',
  sessionId: 'sessionId',
  cptCode: 'cptCode',
  diagCode: 'diagCode',
  additionalDiagCodes: 'additionalDiagCodes',
  assignment: 'assignment',
  totalCost: 'totalCost',
  paidByInsurance: 'paidByInsurance',
  paidByClient: 'paidByClient'
};

exports.Prisma.UserImpersonationLogScalarFieldEnum = {
  id: 'id',
  impersonatedAt: 'impersonatedAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  impersonatorId: 'impersonatorId'
};

exports.Prisma.UserSettingsScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  allowDataProcessing: 'allowDataProcessing',
  hasGivenDataProcessingConsent: 'hasGivenDataProcessingConsent',
  hasGivenSessionSummarisationConsent: 'hasGivenSessionSummarisationConsent',
  maxNumberOfTherapySessionsOverride: 'maxNumberOfTherapySessionsOverride',
  maxNumberOfCoachingSessionsOverride: 'maxNumberOfCoachingSessionsOverride',
  maxNumberOfOneToOneSessionsOverride: 'maxNumberOfOneToOneSessionsOverride'
};

exports.Prisma.UserSettingsHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  propertyUpdated: 'propertyUpdated',
  previousValue: 'previousValue',
  newValue: 'newValue'
};

exports.Prisma.GuestsToUsersScalarFieldEnum = {
  userId: 'userId',
  guestId: 'guestId',
  switchToPersonalPlanScheduledFor: 'switchToPersonalPlanScheduledFor',
  status: 'status'
};

exports.Prisma.ContactDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  surname: 'surname',
  phoneNumber: 'phoneNumber',
  email: 'email',
  address: 'address',
  relationship: 'relationship',
  city: 'city',
  country: 'country',
  timezone: 'timezone'
};

exports.Prisma.ClinicalProfileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  professionalTitle: 'professionalTitle',
  biography: 'biography',
  image: 'image',
  summary: 'summary',
  clinicalExperienceWithId: 'clinicalExperienceWithId',
  clinicalModalityExpertiseId: 'clinicalModalityExpertiseId',
  clinicalProblemExpertiseId: 'clinicalProblemExpertiseId',
  treatableSteps: 'treatableSteps',
  expectedClients: 'expectedClients',
  expectedHours: 'expectedHours',
  insuranceRegions: 'insuranceRegions',
  canProvideCareToOlivans: 'canProvideCareToOlivans',
  canReceiveClients: 'canReceiveClients',
  regionsAllowedToGiveCare: 'regionsAllowedToGiveCare',
  nationalProviderIdentifier: 'nationalProviderIdentifier',
  acceptingClients: 'acceptingClients',
  careTypes: 'careTypes'
};

exports.Prisma.ClinicalModalityExpertiseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  CBT: 'CBT',
  ACT: 'ACT',
  ACT_CBT_LONG_TERM_HEALTH_CONDITION: 'ACT_CBT_LONG_TERM_HEALTH_CONDITION',
  MBCT: 'MBCT',
  MBSR: 'MBSR',
  DEPRESSION_COUNSELLING: 'DEPRESSION_COUNSELLING',
  DIT: 'DIT',
  PSYCHODYNAMIC: 'PSYCHODYNAMIC',
  CAT: 'CAT',
  PWP: 'PWP',
  PERSON_CENTERED_COUNSELLING: 'PERSON_CENTERED_COUNSELLING',
  PROFESSIONAL_COACHING: 'PROFESSIONAL_COACHING',
  COUPLES_COUNSELLING: 'COUPLES_COUNSELLING',
  COACHING: 'COACHING',
  Other: 'Other'
};

exports.Prisma.ClinicalProblemExpertiseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ANGER: 'ANGER',
  ANXIETY: 'ANXIETY',
  ATTENTION_AND_HYPERACTIVITY_CONCERNS: 'ATTENTION_AND_HYPERACTIVITY_CONCERNS',
  BREAKING_HABITS: 'BREAKING_HABITS',
  CULTURAL_IDENTITY: 'CULTURAL_IDENTITY',
  FEELING_DEPRESSED_LOW_MOOD: 'FEELING_DEPRESSED_LOW_MOOD',
  FINDING_PURPOSE: 'FINDING_PURPOSE',
  GRIEF_LOSS: 'GRIEF_LOSS',
  OBSESSIONS_AND_COMPULSIONS: 'OBSESSIONS_AND_COMPULSIONS',
  PERFECTIONISM: 'PERFECTIONISM',
  PROCRASTINATION: 'PROCRASTINATION',
  SELF_ESTEEM: 'SELF_ESTEEM',
  SERIOUS_MENTAL_ILLNESS: 'SERIOUS_MENTAL_ILLNESS',
  SIGNIFICANT_OR_CHRONIC_STRESS: 'SIGNIFICANT_OR_CHRONIC_STRESS',
  SUBSTANCE_ALCOHOL_USE_CONCERNS: 'SUBSTANCE_ALCOHOL_USE_CONCERNS',
  TRAUMA: 'TRAUMA',
  BEING_A_MANAGER_ISSUES: 'BEING_A_MANAGER_ISSUES',
  BURNOUT: 'BURNOUT',
  CAREER_CHANGE: 'CAREER_CHANGE',
  COMMUNICATION_ISSUES_AT_WORK: 'COMMUNICATION_ISSUES_AT_WORK',
  DIVERSITY_EQUITY_INCLUSION_AT_WORK: 'DIVERSITY_EQUITY_INCLUSION_AT_WORK',
  INTERPERSONAL_ISSUES: 'INTERPERSONAL_ISSUES',
  RECENT_PROMOTION: 'RECENT_PROMOTION',
  REMOTE_WORK_ISSUES: 'REMOTE_WORK_ISSUES',
  WORK_LIFE_BALANCE: 'WORK_LIFE_BALANCE',
  EATING_WEIGHT_ISSUES: 'EATING_WEIGHT_ISSUES',
  HEALTH_ANXIETY: 'HEALTH_ANXIETY',
  INSOMNIA: 'INSOMNIA',
  LACK_OF_EXERCISE: 'LACK_OF_EXERCISE',
  LONG_TERM_HEALTH_CONDITION: 'LONG_TERM_HEALTH_CONDITION',
  MINDFULNESS_MEDITATION: 'MINDFULNESS_MEDITATION',
  SLEEP_ISSUES: 'SLEEP_ISSUES',
  BUILDING_NEW_RELATIONSHIPS: 'BUILDING_NEW_RELATIONSHIPS',
  DIVERSITY_EQUITY_INCLUSION: 'DIVERSITY_EQUITY_INCLUSION',
  IMPROVING_MY_RELATIONSHIPS: 'IMPROVING_MY_RELATIONSHIPS',
  NAVIGATING_CONFLICT: 'NAVIGATING_CONFLICT',
  PARENTING_CAREGIVING_FAMILY: 'PARENTING_CAREGIVING_FAMILY',
  SOCIAL_ANXIETY: 'SOCIAL_ANXIETY',
  SEXUAL_DYSFUNCTION: 'SEXUAL_DYSFUNCTION',
  COMPULSIVE_BUYING: 'COMPULSIVE_BUYING',
  DEALING_WITH_DEBT: 'DEALING_WITH_DEBT',
  FINANCIAL_ANXIETY: 'FINANCIAL_ANXIETY',
  FINANCIAL_STABILITY: 'FINANCIAL_STABILITY',
  FINANCIAL_PRESSURE_FROM_FAMILY_MEMBERS: 'FINANCIAL_PRESSURE_FROM_FAMILY_MEMBERS',
  PTSD: 'PTSD'
};

exports.Prisma.ClinicalExperienceWithScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  AGE_18_24: 'AGE_18_24',
  AGE_25_34: 'AGE_25_34',
  AGE_35_44: 'AGE_35_44',
  AGE_45_54: 'AGE_45_54',
  AGE_55_64: 'AGE_55_64',
  AGE_65_74: 'AGE_65_74',
  AGE_75_OR_MORE: 'AGE_75_OR_MORE',
  female: 'female',
  male: 'male',
  lesbian: 'lesbian',
  gay: 'gay',
  bisexual: 'bisexual',
  queer: 'queer',
  pansexual: 'pansexual',
  white: 'white',
  latinx: 'latinx',
  black: 'black',
  east_asian: 'east_asian',
  south_asian: 'south_asian',
  middle_eastern: 'middle_eastern',
  christianity: 'christianity',
  hinduism: 'hinduism',
  judaism: 'judaism',
  islam: 'islam',
  sikhism: 'sikhism',
  buddhism: 'buddhism',
  c_level_executives: 'c_level_executives',
  managers: 'managers',
  regular_employees: 'regular_employees'
};

exports.Prisma.ServiceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  clinicalProfileId: 'clinicalProfileId',
  serviceType: 'serviceType',
  languages: 'languages'
};

exports.Prisma.SchedulerInformationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  accountSub: 'accountSub',
  token: 'token',
  availabilityRules: 'availabilityRules',
  refreshToken: 'refreshToken',
  tokenUpdatedAt: 'tokenUpdatedAt',
  application_calendar_account_sub: 'application_calendar_account_sub',
  application_calendar_refresh_token: 'application_calendar_refresh_token',
  application_calendar_token: 'application_calendar_token',
  has_synced_personal_calendar: 'has_synced_personal_calendar',
  created_calendar_id: 'created_calendar_id'
};

exports.Prisma.UserStrikesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  reason: 'reason',
  appointmentId: 'appointmentId'
};

exports.Prisma.ChatScalarFieldEnum = {
  id: 'id',
  lastNotificationSent: 'lastNotificationSent',
  lastTimeChatChecked: 'lastTimeChatChecked'
};

exports.Prisma.AllowlistScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  role: 'role'
};

exports.Prisma.OrganisationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  adminEmail: 'adminEmail',
  organisationGroupId: 'organisationGroupId'
};

exports.Prisma.OrganisationTeamsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organisationId: 'organisationId',
  teams: 'teams'
};

exports.Prisma.OrganisationSlackIntegrationScalarFieldEnum = {
  id: 'id',
  installationStatus: 'installationStatus',
  token: 'token',
  teamId: 'teamId'
};

exports.Prisma.OrganisationPlanScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  type: 'type',
  organisationId: 'organisationId',
  createdById: 'createdById',
  services: 'services',
  hasDNAChargeEnabled: 'hasDNAChargeEnabled',
  startDate: 'startDate',
  endDate: 'endDate',
  status: 'status',
  maxNumberOfOneToOneSessions: 'maxNumberOfOneToOneSessions',
  maxNumberOfTherapySessions: 'maxNumberOfTherapySessions',
  maxNumberOfCoachingSessions: 'maxNumberOfCoachingSessions',
  maxNumberOfGuestsPerUser: 'maxNumberOfGuestsPerUser',
  maxNumberOfOneToOneSessionsForGuests: 'maxNumberOfOneToOneSessionsForGuests',
  oneToOneSessionsRenewalPeriod: 'oneToOneSessionsRenewalPeriod',
  oneToOneSessionsForGuestsRenewalPeriod: 'oneToOneSessionsForGuestsRenewalPeriod',
  maxNumberOfPublicClasses: 'maxNumberOfPublicClasses',
  maxNumberOfWorkshops: 'maxNumberOfWorkshops',
  lastSessionConsumptionThresholdNotified: 'lastSessionConsumptionThresholdNotified',
  maxNumberOfPublicClassesForGuests: 'maxNumberOfPublicClassesForGuests',
  publicClassesRenewalPeriod: 'publicClassesRenewalPeriod',
  workshopsRenewalPeriod: 'workshopsRenewalPeriod',
  accessReportEngagement: 'accessReportEngagement',
  accessReportCompanyWellbeing: 'accessReportCompanyWellbeing',
  accessCareerCoaching: 'accessCareerCoaching',
  sessionPricePaymentServiceId: 'sessionPricePaymentServiceId',
  sessionDNAPricePaymentServiceId: 'sessionDNAPricePaymentServiceId'
};

exports.Prisma.OrganisationSettingsScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organisationId: 'organisationId',
  ssoEnabled: 'ssoEnabled',
  scimEnabled: 'scimEnabled',
  acceptedSSODomains: 'acceptedSSODomains',
  primarySSODomain: 'primarySSODomain',
  crisisSupportEnabled: 'crisisSupportEnabled',
  allocationNotificationsEnabled: 'allocationNotificationsEnabled'
};

exports.Prisma.OrganisationChangeHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fromOrganisationId: 'fromOrganisationId',
  toOrganisationId: 'toOrganisationId',
  userId: 'userId',
  changedAt: 'changedAt'
};

exports.Prisma.OrganisationSettingsHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  organisationId: 'organisationId',
  propertyUpdated: 'propertyUpdated',
  previousValue: 'previousValue',
  newValue: 'newValue'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expirationDate: 'expirationDate',
  email: 'email',
  organisationId: 'organisationId',
  invitedByUserId: 'invitedByUserId',
  createdUserId: 'createdUserId',
  status: 'status',
  role: 'role',
  linkAsGuestOfInvitee: 'linkAsGuestOfInvitee',
  acceptedAt: 'acceptedAt',
  revokedAt: 'revokedAt',
  emailHash: 'emailHash'
};

exports.Prisma.LetterToProfessionalScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  questionId: 'questionId',
  answerId: 'answerId',
  userId: 'userId',
  assigneeId: 'assigneeId',
  language: 'language'
};

exports.Prisma.PaymentScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  provider: 'provider',
  amount: 'amount',
  refundAmount: 'refundAmount',
  currency: 'currency',
  transactionId: 'transactionId',
  service: 'service',
  transactionRefundId: 'transactionRefundId',
  sessionId: 'sessionId',
  appointmentId: 'appointmentId',
  userId: 'userId',
  checkoutExpiresAt: 'checkoutExpiresAt',
  checkoutId: 'checkoutId',
  id: 'id'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  number: 'number',
  status: 'status',
  type: 'type',
  careStep: 'careStep',
  employeeId: 'employeeId',
  professionalId: 'professionalId',
  remindersId: 'remindersId',
  cancellationId: 'cancellationId',
  sessionRiskManagementId: 'sessionRiskManagementId',
  therapyId: 'therapyId',
  createdById: 'createdById',
  language: 'language',
  tags: 'tags',
  topics: 'topics',
  reason: 'reason',
  isBookedWithShortNotice: 'isBookedWithShortNotice',
  insuranceClaimId: 'insuranceClaimId'
};

exports.Prisma.GroupSessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  language: 'language',
  slots: 'slots',
  cancellationId: 'cancellationId',
  workshopId: 'workshopId',
  durationInMinutes: 'durationInMinutes',
  remindersId: 'remindersId',
  organisationId: 'organisationId',
  private: 'private'
};

exports.Prisma.SessionSettingsScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sessionId: 'sessionId',
  allowDataProcessing: 'allowDataProcessing'
};

exports.Prisma.GroupSessionHostsScalarFieldEnum = {
  groupSessionId: 'groupSessionId',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.GroupSessionParticipantsScalarFieldEnum = {
  groupSessionId: 'groupSessionId',
  userId: 'userId',
  createdAt: 'createdAt',
  hasJoined: 'hasJoined',
  cancellationReason: 'cancellationReason',
  cancelledAt: 'cancelledAt',
  status: 'status'
};

exports.Prisma.ExternalGroupSessionParticipantsScalarFieldEnum = {
  id: 'id',
  groupSessionId: 'groupSessionId',
  createdAt: 'createdAt',
  hasJoined: 'hasJoined',
  status: 'status',
  email: 'email'
};

exports.Prisma.AppointmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  scheduledStartDate: 'scheduledStartDate',
  scheduledEndDate: 'scheduledEndDate',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  roomUrl: 'roomUrl',
  hostRoomUrl: 'hostRoomUrl',
  sessionId: 'sessionId',
  rescheduledToId: 'rescheduledToId',
  rescheduleRequestedById: 'rescheduleRequestedById',
  rescheduledFromId: 'rescheduledFromId',
  meetingId: 'meetingId',
  rescheduleReason: 'rescheduleReason',
  groupSessionId: 'groupSessionId',
  newRoomUrl: 'newRoomUrl',
  newMeetingId: 'newMeetingId'
};

exports.Prisma.SessionRemindersScalarFieldEnum = {
  id: 'id',
  dayBefore: 'dayBefore',
  sessionStarting: 'sessionStarting',
  workshopFeedback: 'workshopFeedback'
};

exports.Prisma.SessionCancellationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reason: 'reason',
  requestedById: 'requestedById'
};

exports.Prisma.SurveyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isCompleted: 'isCompleted',
  name: 'name',
  sessionId: 'sessionId',
  userId: 'userId',
  professionalId: 'professionalId',
  therapyId: 'therapyId',
  groupSessionId: 'groupSessionId'
};

exports.Prisma.SurveyQuestionScalarFieldEnum = {
  id: 'id',
  number: 'number',
  question: 'question',
  answer: 'answer',
  surveyId: 'surveyId',
  clinicalQuestionnaireId: 'clinicalQuestionnaireId'
};

exports.Prisma.ClinicalQuestionnaireScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  score: 'score',
  userId: 'userId',
  therapyId: 'therapyId',
  sessionId: 'sessionId'
};

exports.Prisma.WorkshopScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  private: 'private',
  active: 'active',
  open: 'open',
  organisationId: 'organisationId',
  slug: 'slug',
  category: 'category',
  topics: 'topics',
  color: 'color',
  outcome: 'outcome',
  structure: 'structure',
  subtitle: 'subtitle',
  type: 'type',
  illustration_card: 'illustration_card',
  illustration_cover: 'illustration_cover',
  illustration_email: 'illustration_email',
  featured: 'featured',
  resourceId: 'resourceId'
};

exports.Prisma.WorkshopHostsScalarFieldEnum = {
  userId: 'userId',
  workshopId: 'workshopId',
  createdAt: 'createdAt'
};

exports.Prisma.WorkshopRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  dates: 'dates',
  workshopId: 'workshopId',
  groupSessionId: 'groupSessionId',
  attendeeType: 'attendeeType',
  comments: 'comments',
  customRoomUrl: 'customRoomUrl',
  workshopThemeId: 'workshopThemeId',
  requestedById: 'requestedById',
  creditsToAdd: 'creditsToAdd'
};

exports.Prisma.WorkshopRequestParticipantsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  workshopRequestId: 'workshopRequestId',
  userId: 'userId',
  emailAddress: 'emailAddress'
};

exports.Prisma.WorkshopWaitingListScalarFieldEnum = {
  workshopId: 'workshopId',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.WorkshopAccessListScalarFieldEnum = {
  workshopId: 'workshopId',
  userId: 'userId',
  createdAt: 'createdAt',
  invitedById: 'invitedById'
};

exports.Prisma.WorkshopThemeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  order: 'order',
  slug: 'slug',
  active: 'active',
  illustrationCard: 'illustrationCard',
  illustrationCover: 'illustrationCover',
  illustrationEmail: 'illustrationEmail',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  audience: 'audience',
  challenges: 'challenges',
  outcomes: 'outcomes'
};

exports.Prisma.NoteScalarFieldEnum = {
  id: 'id',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ownerId: 'ownerId',
  type: 'type',
  sessionId: 'sessionId',
  groupSessionId: 'groupSessionId',
  wordCount: 'wordCount'
};

exports.Prisma.NoteLogScalarFieldEnum = {
  id: 'id',
  noteId: 'noteId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  wordCount: 'wordCount'
};

exports.Prisma.SessionRiskManagementScalarFieldEnum = {
  id: 'id',
  riskLevel: 'riskLevel',
  riskManagementPlanId: 'riskManagementPlanId'
};

exports.Prisma.TherapyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  careStep: 'careStep',
  primaryProblem: 'primaryProblem',
  secondaryProblem: 'secondaryProblem',
  status: 'status',
  modality: 'modality',
  careType: 'careType',
  endCareReason: 'endCareReason',
  employeeId: 'employeeId',
  professionalId: 'professionalId',
  createdById: 'createdById',
  language: 'language',
  submissionId: 'submissionId',
  service: 'service',
  chatChannelUrl: 'chatChannelUrl',
  goalWasAchieved: 'goalWasAchieved',
  aboveCaseness: 'aboveCaseness',
  isBookingEnabled: 'isBookingEnabled'
};

exports.Prisma.TherapyStatusHistoryScalarFieldEnum = {
  id: 'id',
  therapyId: 'therapyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  previousStatus: 'previousStatus',
  newStatus: 'newStatus',
  numberOfSessions: 'numberOfSessions',
  GADQuestionnaireId: 'GADQuestionnaireId',
  PHQQuestionnaireId: 'PHQQuestionnaireId',
  statusUpdatedById: 'statusUpdatedById',
  newProfessionalId: 'newProfessionalId',
  previousProfessionalId: 'previousProfessionalId',
  rematchReason: 'rematchReason',
  previousService: 'previousService',
  newService: 'newService'
};

exports.Prisma.ResourceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  name: 'name',
  slug: 'slug',
  source: 'source',
  thumbnail: 'thumbnail',
  description: 'description',
  type: 'type',
  language: 'language',
  category: 'category',
  suitableTherapyModalities: 'suitableTherapyModalities',
  createdByUserId: 'createdByUserId',
  format: 'format',
  topics: 'topics',
  area: 'area',
  subArea: 'subArea',
  imageCard: 'imageCard',
  imageCover: 'imageCover',
  content: 'content',
  sequence: 'sequence',
  resourceThemeId: 'resourceThemeId',
  featured: 'featured',
  isExternal: 'isExternal'
};

exports.Prisma.ResourceHostScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  image: 'image',
  summary: 'summary'
};

exports.Prisma.ResourcesHostsScalarFieldEnum = {
  resourceId: 'resourceId',
  resourceHostId: 'resourceHostId'
};

exports.Prisma.ResourceCourseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  source: 'source',
  type: 'type',
  chapter: 'chapter',
  format: 'format',
  resourceId: 'resourceId'
};

exports.Prisma.SharedResourceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  resourceId: 'resourceId',
  sharedToId: 'sharedToId',
  sharedById: 'sharedById',
  therapyId: 'therapyId',
  workshopId: 'workshopId'
};

exports.Prisma.ResourceThemeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  thumbnail: 'thumbnail',
  slug: 'slug',
  imageCover: 'imageCover',
  startDate: 'startDate',
  endDate: 'endDate',
  featured: 'featured',
  sequence: 'sequence'
};

exports.Prisma.ResourceConsumptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  resourceId: 'resourceId',
  progress: 'progress',
  consumed: 'consumed',
  source: 'source'
};

exports.Prisma.ResourceFavouriteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  resourceId: 'resourceId',
  status: 'status'
};

exports.Prisma.SubAreaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  area: 'area',
  title: 'title',
  subtitle: 'subtitle',
  slug: 'slug'
};

exports.Prisma.RatingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rating: 'rating',
  content: 'content',
  userId: 'userId',
  sessionId: 'sessionId',
  groupSessionId: 'groupSessionId'
};

exports.Prisma.CustomCareRecordEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  eventDate: 'eventDate',
  eventDuration: 'eventDuration',
  additionalDetails: 'additionalDetails',
  isRiskEvent: 'isRiskEvent',
  currentUserTherapyId: 'currentUserTherapyId',
  createdById: 'createdById',
  userId: 'userId'
};

exports.Prisma.DeviceTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  token: 'token'
};

exports.Prisma.SupervisionSubmissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  therapyId: 'therapyId',
  supervisionDate: 'supervisionDate',
  supervisorId: 'supervisorId',
  requestingUserId: 'requestingUserId',
  modalityAndSeverityIsAppropriate: 'modalityAndSeverityIsAppropriate',
  modalityAndSeveritySuggestion: 'modalityAndSeveritySuggestion',
  supervisionPurpose: 'supervisionPurpose',
  professionalPositives: 'professionalPositives',
  professionalImprovements: 'professionalImprovements',
  agreedTreatmentPlan: 'agreedTreatmentPlan',
  recoveryBarriers: 'recoveryBarriers',
  supervisorActions: 'supervisorActions',
  rematchProposed: 'rematchProposed'
};

exports.Prisma.CarePlanRemindersScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firstRemindersCount: 'firstRemindersCount',
  followUpReminders: 'followUpReminders',
  therapyId: 'therapyId',
  carePlanId: 'carePlanId'
};

exports.Prisma.RecommendedResourceSetScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rating: 'rating',
  feedbackNotes: 'feedbackNotes'
};

exports.Prisma.RecommendedResourceItemScalarFieldEnum = {
  recommendedResourceSetId: 'recommendedResourceSetId',
  resourceId: 'resourceId',
  sharedAt: 'sharedAt'
};

exports.Prisma.ExerciseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  type: 'type',
  name: 'name',
  description: 'description',
  fileUrl: 'fileUrl',
  voiceoverUrl: 'voiceoverUrl',
  thumbnailUrl: 'thumbnailUrl',
  isAssignable: 'isAssignable'
};

exports.Prisma.ExerciseAssignmentScalarFieldEnum = {
  id: 'id',
  therapyId: 'therapyId',
  exerciseId: 'exerciseId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  skippedAt: 'skippedAt',
  outcomeSummary: 'outcomeSummary',
  order: 'order',
  executionMode: 'executionMode'
};

exports.Prisma.ProfessionalOrganisationPreferenceScalarFieldEnum = {
  id: 'id',
  professionalId: 'professionalId',
  organisationId: 'organisationId',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reason: 'reason'
};

exports.Prisma.MinimumSupportedVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  platform: 'platform',
  version: 'version'
};

exports.Prisma.OrganisationGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.userOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  surname: 'surname',
  email: 'email',
  emailHash: 'emailHash',
  personalEmail: 'personalEmail',
  personalEmailHash: 'personalEmailHash',
  slackUserId: 'slackUserId',
  schedulerInformationId: 'schedulerInformationId',
  chatId: 'chatId',
  organisationId: 'organisationId',
  contactDetailsId: 'contactDetailsId',
  emergencyContactDetailsId: 'emergencyContactDetailsId',
  generalPracticionerContactDetailsId: 'generalPracticionerContactDetailsId',
  clinicalProfileId: 'clinicalProfileId',
  phone: 'phone',
  city: 'city',
  country: 'country',
  preferredLanguage: 'preferredLanguage',
  timezone: 'timezone',
  slackIntegrationId: 'slackIntegrationId',
  ethnicity: 'ethnicity',
  religion: 'religion',
  personalIdNumber: 'personalIdNumber',
  sexualOrientation: 'sexualOrientation',
  region: 'region',
  apartment: 'apartment',
  streetAddress: 'streetAddress',
  zipCode: 'zipCode',
  paymentServiceCustomerId: 'paymentServiceCustomerId',
  paymentServicePaymentMethodId: 'paymentServicePaymentMethodId',
  organisationTeam: 'organisationTeam'
};

exports.Prisma.insuranceInformationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  planName: 'planName',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  address: 'address',
  phone: 'phone',
  idNumber: 'idNumber',
  insuredName: 'insuredName',
  insuredSurname: 'insuredSurname',
  insuredCity: 'insuredCity',
  insuredState: 'insuredState',
  insuredZipCode: 'insuredZipCode',
  insuredAddress: 'insuredAddress',
  insuredPhone: 'insuredPhone'
};

exports.Prisma.insuranceClaimOrderByRelevanceFieldEnum = {
  id: 'id',
  insuranceInformationId: 'insuranceInformationId',
  sessionId: 'sessionId',
  cptCode: 'cptCode',
  diagCode: 'diagCode',
  additionalDiagCodes: 'additionalDiagCodes'
};

exports.Prisma.userImpersonationLogOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  impersonatorId: 'impersonatorId'
};

exports.Prisma.userSettingsOrderByRelevanceFieldEnum = {
  userId: 'userId'
};

exports.Prisma.userSettingsHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  propertyUpdated: 'propertyUpdated',
  previousValue: 'previousValue',
  newValue: 'newValue'
};

exports.Prisma.guestsToUsersOrderByRelevanceFieldEnum = {
  userId: 'userId',
  guestId: 'guestId'
};

exports.Prisma.contactDetailsOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  surname: 'surname',
  phoneNumber: 'phoneNumber',
  email: 'email',
  address: 'address',
  relationship: 'relationship',
  city: 'city',
  country: 'country',
  timezone: 'timezone'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.clinicalProfileOrderByRelevanceFieldEnum = {
  id: 'id',
  professionalTitle: 'professionalTitle',
  image: 'image',
  summary: 'summary',
  clinicalExperienceWithId: 'clinicalExperienceWithId',
  clinicalModalityExpertiseId: 'clinicalModalityExpertiseId',
  clinicalProblemExpertiseId: 'clinicalProblemExpertiseId',
  regionsAllowedToGiveCare: 'regionsAllowedToGiveCare',
  nationalProviderIdentifier: 'nationalProviderIdentifier'
};

exports.Prisma.clinicalModalityExpertiseOrderByRelevanceFieldEnum = {
  id: 'id',
  Other: 'Other'
};

exports.Prisma.clinicalProblemExpertiseOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.clinicalExperienceWithOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.serviceOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  clinicalProfileId: 'clinicalProfileId'
};

exports.Prisma.schedulerInformationOrderByRelevanceFieldEnum = {
  id: 'id',
  accountSub: 'accountSub',
  token: 'token',
  availabilityRules: 'availabilityRules',
  refreshToken: 'refreshToken',
  application_calendar_account_sub: 'application_calendar_account_sub',
  application_calendar_refresh_token: 'application_calendar_refresh_token',
  application_calendar_token: 'application_calendar_token',
  created_calendar_id: 'created_calendar_id'
};

exports.Prisma.userStrikesOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  appointmentId: 'appointmentId'
};

exports.Prisma.chatOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.allowlistOrderByRelevanceFieldEnum = {
  email: 'email'
};

exports.Prisma.organisationOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  adminEmail: 'adminEmail',
  organisationGroupId: 'organisationGroupId'
};

exports.Prisma.organisationTeamsOrderByRelevanceFieldEnum = {
  id: 'id',
  organisationId: 'organisationId',
  teams: 'teams'
};

exports.Prisma.organisationSlackIntegrationOrderByRelevanceFieldEnum = {
  id: 'id',
  token: 'token',
  teamId: 'teamId'
};

exports.Prisma.organisationPlanOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  organisationId: 'organisationId',
  createdById: 'createdById',
  sessionPricePaymentServiceId: 'sessionPricePaymentServiceId',
  sessionDNAPricePaymentServiceId: 'sessionDNAPricePaymentServiceId'
};

exports.Prisma.organisationSettingsOrderByRelevanceFieldEnum = {
  organisationId: 'organisationId',
  acceptedSSODomains: 'acceptedSSODomains',
  primarySSODomain: 'primarySSODomain'
};

exports.Prisma.organisationChangeHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  fromOrganisationId: 'fromOrganisationId',
  toOrganisationId: 'toOrganisationId',
  userId: 'userId'
};

exports.Prisma.organisationSettingsHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  organisationId: 'organisationId',
  propertyUpdated: 'propertyUpdated',
  previousValue: 'previousValue',
  newValue: 'newValue'
};

exports.Prisma.invitationOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  organisationId: 'organisationId',
  invitedByUserId: 'invitedByUserId',
  createdUserId: 'createdUserId',
  emailHash: 'emailHash'
};

exports.Prisma.letterToProfessionalOrderByRelevanceFieldEnum = {
  id: 'id',
  questionId: 'questionId',
  answerId: 'answerId',
  userId: 'userId',
  assigneeId: 'assigneeId'
};

exports.Prisma.paymentOrderByRelevanceFieldEnum = {
  currency: 'currency',
  transactionId: 'transactionId',
  transactionRefundId: 'transactionRefundId',
  sessionId: 'sessionId',
  appointmentId: 'appointmentId',
  userId: 'userId',
  checkoutId: 'checkoutId',
  id: 'id'
};

exports.Prisma.sessionOrderByRelevanceFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  professionalId: 'professionalId',
  remindersId: 'remindersId',
  cancellationId: 'cancellationId',
  sessionRiskManagementId: 'sessionRiskManagementId',
  therapyId: 'therapyId',
  createdById: 'createdById',
  tags: 'tags',
  topics: 'topics',
  reason: 'reason',
  insuranceClaimId: 'insuranceClaimId'
};

exports.Prisma.groupSessionOrderByRelevanceFieldEnum = {
  id: 'id',
  cancellationId: 'cancellationId',
  workshopId: 'workshopId',
  remindersId: 'remindersId',
  organisationId: 'organisationId'
};

exports.Prisma.sessionSettingsOrderByRelevanceFieldEnum = {
  sessionId: 'sessionId'
};

exports.Prisma.groupSessionHostsOrderByRelevanceFieldEnum = {
  groupSessionId: 'groupSessionId',
  userId: 'userId'
};

exports.Prisma.groupSessionParticipantsOrderByRelevanceFieldEnum = {
  groupSessionId: 'groupSessionId',
  userId: 'userId'
};

exports.Prisma.externalGroupSessionParticipantsOrderByRelevanceFieldEnum = {
  id: 'id',
  groupSessionId: 'groupSessionId',
  email: 'email'
};

exports.Prisma.appointmentOrderByRelevanceFieldEnum = {
  id: 'id',
  roomUrl: 'roomUrl',
  hostRoomUrl: 'hostRoomUrl',
  sessionId: 'sessionId',
  rescheduledToId: 'rescheduledToId',
  rescheduleRequestedById: 'rescheduleRequestedById',
  rescheduledFromId: 'rescheduledFromId',
  meetingId: 'meetingId',
  groupSessionId: 'groupSessionId',
  newRoomUrl: 'newRoomUrl',
  newMeetingId: 'newMeetingId'
};

exports.Prisma.sessionRemindersOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.sessionCancellationOrderByRelevanceFieldEnum = {
  id: 'id',
  requestedById: 'requestedById'
};

exports.Prisma.surveyOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  userId: 'userId',
  professionalId: 'professionalId',
  therapyId: 'therapyId',
  groupSessionId: 'groupSessionId'
};

exports.Prisma.surveyQuestionOrderByRelevanceFieldEnum = {
  id: 'id',
  question: 'question',
  answer: 'answer',
  surveyId: 'surveyId',
  clinicalQuestionnaireId: 'clinicalQuestionnaireId'
};

exports.Prisma.clinicalQuestionnaireOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  therapyId: 'therapyId',
  sessionId: 'sessionId'
};

exports.Prisma.workshopOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  organisationId: 'organisationId',
  slug: 'slug',
  color: 'color',
  outcome: 'outcome',
  structure: 'structure',
  subtitle: 'subtitle',
  illustration_card: 'illustration_card',
  illustration_cover: 'illustration_cover',
  illustration_email: 'illustration_email',
  resourceId: 'resourceId'
};

exports.Prisma.workshopHostsOrderByRelevanceFieldEnum = {
  userId: 'userId',
  workshopId: 'workshopId'
};

exports.Prisma.workshopRequestOrderByRelevanceFieldEnum = {
  id: 'id',
  workshopId: 'workshopId',
  groupSessionId: 'groupSessionId',
  comments: 'comments',
  customRoomUrl: 'customRoomUrl',
  workshopThemeId: 'workshopThemeId',
  requestedById: 'requestedById'
};

exports.Prisma.workshopRequestParticipantsOrderByRelevanceFieldEnum = {
  id: 'id',
  workshopRequestId: 'workshopRequestId',
  userId: 'userId',
  emailAddress: 'emailAddress'
};

exports.Prisma.workshopWaitingListOrderByRelevanceFieldEnum = {
  workshopId: 'workshopId',
  userId: 'userId'
};

exports.Prisma.workshopAccessListOrderByRelevanceFieldEnum = {
  workshopId: 'workshopId',
  userId: 'userId',
  invitedById: 'invitedById'
};

exports.Prisma.workshopThemeOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  illustrationCard: 'illustrationCard',
  illustrationCover: 'illustrationCover',
  illustrationEmail: 'illustrationEmail',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  audience: 'audience',
  challenges: 'challenges',
  outcomes: 'outcomes'
};

exports.Prisma.noteOrderByRelevanceFieldEnum = {
  id: 'id',
  content: 'content',
  ownerId: 'ownerId',
  sessionId: 'sessionId',
  groupSessionId: 'groupSessionId'
};

exports.Prisma.noteLogOrderByRelevanceFieldEnum = {
  id: 'id',
  noteId: 'noteId',
  content: 'content'
};

exports.Prisma.sessionRiskManagementOrderByRelevanceFieldEnum = {
  id: 'id',
  riskManagementPlanId: 'riskManagementPlanId'
};

exports.Prisma.therapyOrderByRelevanceFieldEnum = {
  id: 'id',
  careStep: 'careStep',
  primaryProblem: 'primaryProblem',
  secondaryProblem: 'secondaryProblem',
  modality: 'modality',
  careType: 'careType',
  employeeId: 'employeeId',
  professionalId: 'professionalId',
  createdById: 'createdById',
  submissionId: 'submissionId',
  chatChannelUrl: 'chatChannelUrl',
  goalWasAchieved: 'goalWasAchieved',
  aboveCaseness: 'aboveCaseness'
};

exports.Prisma.therapyStatusHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  therapyId: 'therapyId',
  GADQuestionnaireId: 'GADQuestionnaireId',
  PHQQuestionnaireId: 'PHQQuestionnaireId',
  statusUpdatedById: 'statusUpdatedById',
  newProfessionalId: 'newProfessionalId',
  previousProfessionalId: 'previousProfessionalId'
};

exports.Prisma.resourceOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  source: 'source',
  thumbnail: 'thumbnail',
  description: 'description',
  createdByUserId: 'createdByUserId',
  format: 'format',
  imageCard: 'imageCard',
  imageCover: 'imageCover',
  content: 'content',
  resourceThemeId: 'resourceThemeId'
};

exports.Prisma.resourceHostOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  image: 'image',
  summary: 'summary'
};

exports.Prisma.resourcesHostsOrderByRelevanceFieldEnum = {
  resourceId: 'resourceId',
  resourceHostId: 'resourceHostId'
};

exports.Prisma.resourceCourseOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  source: 'source',
  format: 'format',
  resourceId: 'resourceId'
};

exports.Prisma.sharedResourceOrderByRelevanceFieldEnum = {
  id: 'id',
  resourceId: 'resourceId',
  sharedToId: 'sharedToId',
  sharedById: 'sharedById',
  therapyId: 'therapyId',
  workshopId: 'workshopId'
};

exports.Prisma.resourceThemeOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  thumbnail: 'thumbnail',
  slug: 'slug',
  imageCover: 'imageCover'
};

exports.Prisma.resourceConsumptionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  resourceId: 'resourceId'
};

exports.Prisma.resourceFavouriteOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  resourceId: 'resourceId'
};

exports.Prisma.subAreaOrderByRelevanceFieldEnum = {
  title: 'title',
  subtitle: 'subtitle',
  slug: 'slug'
};

exports.Prisma.ratingOrderByRelevanceFieldEnum = {
  id: 'id',
  content: 'content',
  userId: 'userId',
  sessionId: 'sessionId',
  groupSessionId: 'groupSessionId'
};

exports.Prisma.customCareRecordEventOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  additionalDetails: 'additionalDetails',
  currentUserTherapyId: 'currentUserTherapyId',
  createdById: 'createdById',
  userId: 'userId'
};

exports.Prisma.deviceTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  token: 'token'
};

exports.Prisma.supervisionSubmissionOrderByRelevanceFieldEnum = {
  id: 'id',
  therapyId: 'therapyId',
  supervisorId: 'supervisorId',
  requestingUserId: 'requestingUserId',
  modalityAndSeveritySuggestion: 'modalityAndSeveritySuggestion',
  supervisionPurpose: 'supervisionPurpose',
  professionalPositives: 'professionalPositives',
  professionalImprovements: 'professionalImprovements',
  agreedTreatmentPlan: 'agreedTreatmentPlan',
  recoveryBarriers: 'recoveryBarriers',
  supervisorActions: 'supervisorActions'
};

exports.Prisma.carePlanRemindersOrderByRelevanceFieldEnum = {
  id: 'id',
  therapyId: 'therapyId',
  carePlanId: 'carePlanId'
};

exports.Prisma.recommendedResourceSetOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  feedbackNotes: 'feedbackNotes'
};

exports.Prisma.recommendedResourceItemOrderByRelevanceFieldEnum = {
  recommendedResourceSetId: 'recommendedResourceSetId',
  resourceId: 'resourceId'
};

exports.Prisma.exerciseOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  fileUrl: 'fileUrl',
  voiceoverUrl: 'voiceoverUrl',
  thumbnailUrl: 'thumbnailUrl'
};

exports.Prisma.exerciseAssignmentOrderByRelevanceFieldEnum = {
  id: 'id',
  therapyId: 'therapyId',
  exerciseId: 'exerciseId',
  userId: 'userId',
  outcomeSummary: 'outcomeSummary'
};

exports.Prisma.professionalOrganisationPreferenceOrderByRelevanceFieldEnum = {
  id: 'id',
  professionalId: 'professionalId',
  organisationId: 'organisationId',
  reason: 'reason'
};

exports.Prisma.minimumSupportedVersionOrderByRelevanceFieldEnum = {
  id: 'id',
  version: 'version'
};

exports.Prisma.organisationGroupOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description'
};
exports.UserGender = exports.$Enums.UserGender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  NON_BINARY: 'NON_BINARY',
  UNSURE: 'UNSURE',
  PREFER_NOT_TO_SAY: 'PREFER_NOT_TO_SAY',
  OTHER: 'OTHER'
};

exports.UserStatus = exports.$Enums.UserStatus = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED'
};

exports.UserAgeGroup = exports.$Enums.UserAgeGroup = {
  AGE_18_24: 'AGE_18_24',
  AGE_25_34: 'AGE_25_34',
  AGE_35_44: 'AGE_35_44',
  AGE_45_54: 'AGE_45_54',
  AGE_55_64: 'AGE_55_64',
  AGE_65_74: 'AGE_65_74',
  AGE_75_OR_MORE: 'AGE_75_OR_MORE',
  PREFER_NOT_TO_SAY: 'PREFER_NOT_TO_SAY'
};

exports.UserRole = exports.$Enums.UserRole = {
  ADMIN: 'ADMIN',
  IMPERSONATOR: 'IMPERSONATOR',
  MHP: 'MHP',
  EMPLOYEE: 'EMPLOYEE',
  ORGANISATION_ADMIN: 'ORGANISATION_ADMIN',
  CLINICAL_SUPERVISOR: 'CLINICAL_SUPERVISOR',
  EXTERNAL_CLINICAL_SUPERVISOR: 'EXTERNAL_CLINICAL_SUPERVISOR',
  MANAGER: 'MANAGER',
  MENTOR: 'MENTOR'
};

exports.SessionLanguage = exports.$Enums.SessionLanguage = {
  en: 'en',
  es: 'es',
  ur: 'ur',
  ar: 'ar',
  pt: 'pt',
  hi: 'hi',
  fr: 'fr',
  uk: 'uk',
  ru: 'ru',
  de: 'de',
  it: 'it',
  pl: 'pl',
  el: 'el',
  id: 'id',
  ro: 'ro',
  sr: 'sr',
  cmn: 'cmn',
  yue: 'yue',
  hu: 'hu',
  he: 'he',
  nl: 'nl',
  hr: 'hr',
  bg: 'bg',
  et: 'et',
  lv: 'lv',
  lt: 'lt',
  bs: 'bs',
  sk: 'sk',
  cnr: 'cnr',
  tr: 'tr',
  sq: 'sq',
  th: 'th',
  ms: 'ms',
  fil: 'fil',
  ja: 'ja',
  no: 'no',
  sv: 'sv',
  da: 'da'
};

exports.InsuranceRelation = exports.$Enums.InsuranceRelation = {
  SELF: 'SELF',
  SPOUSE: 'SPOUSE',
  CHILD: 'CHILD',
  OTHER: 'OTHER'
};

exports.InsurancePlan = exports.$Enums.InsurancePlan = {
  MEDICARE: 'MEDICARE',
  MEDICAID: 'MEDICAID',
  TRICARE: 'TRICARE',
  CHAMPVA: 'CHAMPVA',
  GROUP: 'GROUP',
  FECA: 'FECA',
  OTHER: 'OTHER'
};

exports.InsuranceClaimStatus = exports.$Enums.InsuranceClaimStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
};

exports.InsuranceClaimAssignment = exports.$Enums.InsuranceClaimAssignment = {
  MHP: 'MHP',
  EMPLOYEE: 'EMPLOYEE'
};

exports.GuestStatus = exports.$Enums.GuestStatus = {
  ACTIVE: 'ACTIVE',
  REVOKED: 'REVOKED',
  PENDING_INVITATION: 'PENDING_INVITATION',
  PENDING_REVOKE: 'PENDING_REVOKE',
  MOVED_TO_PERSONAL_PLAN: 'MOVED_TO_PERSONAL_PLAN'
};

exports.ProfessionalInsuranceRegion = exports.$Enums.ProfessionalInsuranceRegion = {
  EU: 'EU',
  UK: 'UK',
  CA: 'CA',
  US: 'US',
  REST_OF_WORLD: 'REST_OF_WORLD'
};

exports.CareType = exports.$Enums.CareType = {
  THERAPEUTIC_STRUCTURED: 'THERAPEUTIC_STRUCTURED',
  THERAPEUTIC_UNSTRUCTURED: 'THERAPEUTIC_UNSTRUCTURED',
  COACHING: 'COACHING',
  CAREER_COACHING: 'CAREER_COACHING',
  HYBRID_CARE: 'HYBRID_CARE'
};

exports.ServiceType = exports.$Enums.ServiceType = {
  DROP_IN: 'DROP_IN',
  MANAGER_ONE_TO_ONE: 'MANAGER_ONE_TO_ONE',
  THERAPY: 'THERAPY',
  ASK_A_THERAPIST: 'ASK_A_THERAPIST',
  WORKSHOP: 'WORKSHOP',
  PRIVATE_WORKSHOP: 'PRIVATE_WORKSHOP',
  TALK: 'TALK',
  TEST: 'TEST',
  TEXT_THERAPY: 'TEXT_THERAPY',
  HYBRID_CARE: 'HYBRID_CARE'
};

exports.UserStrikeReason = exports.$Enums.UserStrikeReason = {
  LATE_RESCHEDULE: 'LATE_RESCHEDULE',
  LATE_CANCELLATION: 'LATE_CANCELLATION',
  NO_SHOW: 'NO_SHOW'
};

exports.SlackInstallationStatus = exports.$Enums.SlackInstallationStatus = {
  PENDING: 'PENDING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS'
};

exports.OrganisationPlanType = exports.$Enums.OrganisationPlanType = {
  TRIAL: 'TRIAL',
  FULL: 'FULL',
  WORKSHOP_ONLY: 'WORKSHOP_ONLY'
};

exports.OrganisationPlanStatus = exports.$Enums.OrganisationPlanStatus = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  NOT_STARTED: 'NOT_STARTED'
};

exports.OrganisationPlanRenewalPeriod = exports.$Enums.OrganisationPlanRenewalPeriod = {
  YEARLY: 'YEARLY',
  MONTHLY: 'MONTHLY'
};

exports.SessionConsumptionThreshold = exports.$Enums.SessionConsumptionThreshold = {
  HALF: 'HALF',
  SEVENTY_FIVE_PERCENT: 'SEVENTY_FIVE_PERCENT',
  EIGHTY_FIVE_PERCENT: 'EIGHTY_FIVE_PERCENT',
  NINETY_FIVE_PERCENT: 'NINETY_FIVE_PERCENT',
  EXHAUSTED: 'EXHAUSTED'
};

exports.InvitationStatus = exports.$Enums.InvitationStatus = {
  INVITED: 'INVITED',
  ACCEPTED: 'ACCEPTED',
  REVOKED: 'REVOKED'
};

exports.LetterToProfessionalStatus = exports.$Enums.LetterToProfessionalStatus = {
  PENDING_ANSWER: 'PENDING_ANSWER',
  ANSWERED: 'ANSWERED'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED'
};

exports.PaymentType = exports.$Enums.PaymentType = {
  SESSION_PAYMENT: 'SESSION_PAYMENT',
  SESSION_DNA_CHARGE: 'SESSION_DNA_CHARGE'
};

exports.PaymentProvider = exports.$Enums.PaymentProvider = {
  STRIPE: 'STRIPE'
};

exports.SessionStatus = exports.$Enums.SessionStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  CANCELLED_LATE: 'CANCELLED_LATE',
  COMPLETED: 'COMPLETED',
  EMPLOYEE_NO_SHOW: 'EMPLOYEE_NO_SHOW',
  PROFESSIONAL_NO_SHOW: 'PROFESSIONAL_NO_SHOW',
  NO_SHOW: 'NO_SHOW',
  SCHEDULED: 'SCHEDULED',
  PAYMENT_EXPIRED: 'PAYMENT_EXPIRED',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT'
};

exports.SessionType = exports.$Enums.SessionType = {
  DROP_IN: 'DROP_IN',
  MANAGER_ONE_TO_ONE: 'MANAGER_ONE_TO_ONE',
  THERAPY: 'THERAPY',
  TEST: 'TEST',
  WORKSHOP: 'WORKSHOP'
};

exports.GroupSessionCancellationReason = exports.$Enums.GroupSessionCancellationReason = {
  LAST_MINUTE_CALENDAR_CONFLICT: 'LAST_MINUTE_CALENDAR_CONFLICT',
  WORKSHOP_IS_TOO_LONG: 'WORKSHOP_IS_TOO_LONG',
  NOT_FEELING_UP_TO_IT: 'NOT_FEELING_UP_TO_IT',
  OTHER: 'OTHER'
};

exports.GroupSessionParticipantStatus = exports.$Enums.GroupSessionParticipantStatus = {
  REGISTERED: 'REGISTERED',
  CANCELLED: 'CANCELLED',
  CANCELLED_LATE: 'CANCELLED_LATE'
};

exports.AppointmentStatus = exports.$Enums.AppointmentStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  CANCELLED_LATE: 'CANCELLED_LATE',
  COMPLETED: 'COMPLETED',
  EMPLOYEE_NO_SHOW: 'EMPLOYEE_NO_SHOW',
  PROFESSIONAL_NO_SHOW: 'PROFESSIONAL_NO_SHOW',
  NO_SHOW: 'NO_SHOW',
  RESCHEDULED: 'RESCHEDULED',
  RESCHEDULED_LATE: 'RESCHEDULED_LATE',
  SCHEDULED: 'SCHEDULED',
  PAYMENT_EXPIRED: 'PAYMENT_EXPIRED',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT'
};

exports.RescheduleReason = exports.$Enums.RescheduleReason = {
  JURY_SERVICE: 'JURY_SERVICE',
  MEDICAL_EMERGENCY: 'MEDICAL_EMERGENCY',
  OTHER: 'OTHER',
  PERSONAL_ISSUE: 'PERSONAL_ISSUE',
  PROFESSIONAL_REQUEST: 'PROFESSIONAL_REQUEST',
  WORK_RELATED_ISSUE: 'WORK_RELATED_ISSUE'
};

exports.CancellationReason = exports.$Enums.CancellationReason = {
  JURY_SERVICE: 'JURY_SERVICE',
  MEDICAL_EMERGENCY: 'MEDICAL_EMERGENCY',
  OTHER: 'OTHER',
  PERSONAL_ISSUE: 'PERSONAL_ISSUE',
  PROFESSIONAL_REQUEST: 'PROFESSIONAL_REQUEST',
  CS_REQUEST: 'CS_REQUEST',
  WORK_RELATED_ISSUE: 'WORK_RELATED_ISSUE',
  USER_SUSPENDED: 'USER_SUSPENDED'
};

exports.SurveyName = exports.$Enums.SurveyName = {
  EMPLOYEE_SATISFACTION_AFTER_FIRST_SESSION: 'EMPLOYEE_SATISFACTION_AFTER_FIRST_SESSION',
  EMPLOYEE_FEEDBACK_ON_PROFESSIONAL: 'EMPLOYEE_FEEDBACK_ON_PROFESSIONAL',
  EMPLOYEE_SYMPTOMS_TRACKING: 'EMPLOYEE_SYMPTOMS_TRACKING',
  EMPLOYEE_PENDING_THERAPY_MATCH: 'EMPLOYEE_PENDING_THERAPY_MATCH',
  EMPLOYEE_SATISFACTION_AFTER_WORKSHOP: 'EMPLOYEE_SATISFACTION_AFTER_WORKSHOP',
  EMPLOYEE_CAREER_COACHING_PROGRESS: 'EMPLOYEE_CAREER_COACHING_PROGRESS'
};

exports.ClinicalQuestionnaireType = exports.$Enums.ClinicalQuestionnaireType = {
  PHQ_9: 'PHQ_9',
  GAD_7: 'GAD_7',
  PHQ_2: 'PHQ_2',
  GAD_2: 'GAD_2'
};

exports.WorkshopType = exports.$Enums.WorkshopType = {
  CLASS: 'CLASS',
  TALK: 'TALK',
  PRACTICE: 'PRACTICE',
  MANAGER_WORKSHOP: 'MANAGER_WORKSHOP',
  WORKSHOP_ONLY: 'WORKSHOP_ONLY'
};

exports.MentalHealthPillars = exports.$Enums.MentalHealthPillars = {
  FINANCIAL: 'FINANCIAL',
  EMOTIONAL: 'EMOTIONAL',
  SOCIAL: 'SOCIAL',
  PROFESSIONAL: 'PROFESSIONAL',
  PHYSICAL: 'PHYSICAL'
};

exports.MentalHealthTopics = exports.$Enums.MentalHealthTopics = {
  ADJUSTMENT_DISORDER: 'ADJUSTMENT_DISORDER',
  ANGER: 'ANGER',
  ANXIETY: 'ANXIETY',
  ATTENTION_AND_HYPERACTIVITY_CONCERNS: 'ATTENTION_AND_HYPERACTIVITY_CONCERNS',
  BEREAVEMENT_REACTION: 'BEREAVEMENT_REACTION',
  BI_POLAR_DEPRESSION: 'BI_POLAR_DEPRESSION',
  BODY_DYSMORPHIA: 'BODY_DYSMORPHIA',
  BREAKING_HABITS: 'BREAKING_HABITS',
  CULTURAL_IDENTITY: 'CULTURAL_IDENTITY',
  DEPRESSION: 'DEPRESSION',
  FEELING_DEPRESSED_LOW_MOOD: 'FEELING_DEPRESSED_LOW_MOOD',
  FINDING_PURPOSE: 'FINDING_PURPOSE',
  GAMBLING_NON_SUBSTANCE_ADDICTIONS: 'GAMBLING_NON_SUBSTANCE_ADDICTIONS',
  GENERALIZED_ANXIETY_DISORDER: 'GENERALIZED_ANXIETY_DISORDER',
  GRIEF_LOSS: 'GRIEF_LOSS',
  INDECISION: 'INDECISION',
  LACK_OF_CONFIDENCE: 'LACK_OF_CONFIDENCE',
  OBSESSIONS_AND_COMPULSIONS: 'OBSESSIONS_AND_COMPULSIONS',
  OCD: 'OCD',
  PANIC_DISORDER_WITH_AGORAPHOBIA: 'PANIC_DISORDER_WITH_AGORAPHOBIA',
  PANIC_DISORDER_WITHOUT_AGORAPHOBIA: 'PANIC_DISORDER_WITHOUT_AGORAPHOBIA',
  PERFECTIONISM: 'PERFECTIONISM',
  PHOBIAS: 'PHOBIAS',
  PROCRASTINATION: 'PROCRASTINATION',
  PTSD: 'PTSD',
  RUMINATION: 'RUMINATION',
  SELF_ESTEEM: 'SELF_ESTEEM',
  SERIOUS_MENTAL_ILLNESS: 'SERIOUS_MENTAL_ILLNESS',
  SIGNIFICANT_OR_CHRONIC_STRESS: 'SIGNIFICANT_OR_CHRONIC_STRESS',
  SKIN_PICKING: 'SKIN_PICKING',
  SUBSTANCE_ALCOHOL_USE_CONCERNS: 'SUBSTANCE_ALCOHOL_USE_CONCERNS',
  TRAUMA: 'TRAUMA',
  TRICHOTILLOMANIA: 'TRICHOTILLOMANIA',
  WORRY_ABOUT_BURNOUT: 'WORRY_ABOUT_BURNOUT',
  WORRY_ABOUT_PERFORMANCE_AT_WORK: 'WORRY_ABOUT_PERFORMANCE_AT_WORK',
  UNHAPPY_AT_WORK: 'UNHAPPY_AT_WORK',
  HELP_WITH_ADOPTING_HEALTHIER_HABITS: 'HELP_WITH_ADOPTING_HEALTHIER_HABITS',
  BEING_A_MANAGER_FOR_THE_FIRST_TIME: 'BEING_A_MANAGER_FOR_THE_FIRST_TIME',
  BEING_A_MANAGER_ISSUES: 'BEING_A_MANAGER_ISSUES',
  BEING_PROMOTED: 'BEING_PROMOTED',
  BURNOUT: 'BURNOUT',
  CAREER_CHANGE: 'CAREER_CHANGE',
  COMMUNICATION_ISSUES_AT_WORK: 'COMMUNICATION_ISSUES_AT_WORK',
  DEALING_WITH_UNCERTAINTY_AT_WORK: 'DEALING_WITH_UNCERTAINTY_AT_WORK',
  DECISION_MAKING: 'DECISION_MAKING',
  DIVERSITY_EQUITY_INCLUSION_AT_WORK: 'DIVERSITY_EQUITY_INCLUSION_AT_WORK',
  GIVING_RECEIVING_FEEDBACK: 'GIVING_RECEIVING_FEEDBACK',
  IMPOSTER_SYNDROME: 'IMPOSTER_SYNDROME',
  INTERPERSONAL_ISSUES: 'INTERPERSONAL_ISSUES',
  RECENT_PROMOTION: 'RECENT_PROMOTION',
  REMOTE_WORK_ISSUES: 'REMOTE_WORK_ISSUES',
  STRESS_AND_WORRY_AT_WORK: 'STRESS_AND_WORRY_AT_WORK',
  WORK_LIFE_BALANCE: 'WORK_LIFE_BALANCE',
  HELP_WITH_WORK_RELATED_ISSUE: 'HELP_WITH_WORK_RELATED_ISSUE',
  CHRONIC_PAIN: 'CHRONIC_PAIN',
  EATING_WEIGHT_ISSUES: 'EATING_WEIGHT_ISSUES',
  HEALTH_ANXIETY: 'HEALTH_ANXIETY',
  INSOMNIA: 'INSOMNIA',
  LACK_OF_EXERCISE: 'LACK_OF_EXERCISE',
  LONG_TERM_HEALTH_CONDITION: 'LONG_TERM_HEALTH_CONDITION',
  MEDICALLY_UNEXPLAINED_SYMPTOMS: 'MEDICALLY_UNEXPLAINED_SYMPTOMS',
  MINDFULNESS_MEDITATION: 'MINDFULNESS_MEDITATION',
  QUITTING_SMOKING: 'QUITTING_SMOKING',
  SLEEP_ISSUES: 'SLEEP_ISSUES',
  ASSERTIVENESS: 'ASSERTIVENESS',
  BEING_A_CARER: 'BEING_A_CARER',
  BUILDING_NEW_RELATIONSHIPS: 'BUILDING_NEW_RELATIONSHIPS',
  BULLYING: 'BULLYING',
  DIVERSITY_EQUITY_INCLUSION: 'DIVERSITY_EQUITY_INCLUSION',
  IMPROVING_MY_RELATIONSHIPS: 'IMPROVING_MY_RELATIONSHIPS',
  MANAGING_CONFLICT: 'MANAGING_CONFLICT',
  NAVIGATING_CONFLICT: 'NAVIGATING_CONFLICT',
  PARENTING_CAREGIVING_FAMILY: 'PARENTING_CAREGIVING_FAMILY',
  SEXUAL_DYSFUNCTION: 'SEXUAL_DYSFUNCTION',
  SOCIAL_ANXIETY: 'SOCIAL_ANXIETY',
  SPEAKING_IN_FRONT_OF_OTHERS: 'SPEAKING_IN_FRONT_OF_OTHERS',
  COMPULSIVE_BUYING: 'COMPULSIVE_BUYING',
  DEALING_WITH_DEBT: 'DEALING_WITH_DEBT',
  DEALING_WITH_FINANCIAL_WORRY: 'DEALING_WITH_FINANCIAL_WORRY',
  FINANCIAL_ANXIETY: 'FINANCIAL_ANXIETY',
  FINANCIAL_STABILITY: 'FINANCIAL_STABILITY',
  FINANCIAL_PRESSURE_FROM_FAMILY_MEMBERS: 'FINANCIAL_PRESSURE_FROM_FAMILY_MEMBERS',
  OVERALL_WELLNESS: 'OVERALL_WELLNESS'
};

exports.WorkshopRequestStatus = exports.$Enums.WorkshopRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED'
};

exports.WorkshopAttendeeType = exports.$Enums.WorkshopAttendeeType = {
  MIXED: 'MIXED',
  MANAGEMENT: 'MANAGEMENT',
  LEADERSHIP: 'LEADERSHIP',
  HUMAN_RESOURCE: 'HUMAN_RESOURCE',
  OTHER: 'OTHER'
};

exports.NoteType = exports.$Enums.NoteType = {
  RISK_MANAGEMENT_PLAN: 'RISK_MANAGEMENT_PLAN',
  CLINICAL_NOTE: 'CLINICAL_NOTE',
  ASK_A_PROFESSIONAL: 'ASK_A_PROFESSIONAL'
};

exports.SessionRiskLevel = exports.$Enums.SessionRiskLevel = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
};

exports.TherapyStatus = exports.$Enums.TherapyStatus = {
  ACTIVE: 'ACTIVE',
  CARE_ENDED: 'CARE_ENDED',
  CREATED: 'CREATED',
  FOLLOW_UP: 'FOLLOW_UP',
  REMATCHED: 'REMATCHED'
};

exports.EndCareReason = exports.$Enums.EndCareReason = {
  COMPANY_CONTRACT_ENDED: 'COMPANY_CONTRACT_ENDED',
  EMPLOYEE_IS_NOT_SUITABLE_FOR_OLIVA: 'EMPLOYEE_IS_NOT_SUITABLE_FOR_OLIVA',
  EMPLOYEE_LEFT_COMPANY: 'EMPLOYEE_LEFT_COMPANY',
  EMPLOYEE_REQUEST: 'EMPLOYEE_REQUEST',
  MHP_LEFT_OLIVA: 'MHP_LEFT_OLIVA',
  NO_CONTACT_FROM_EMPLOYEE: 'NO_CONTACT_FROM_EMPLOYEE',
  REMATCHED: 'REMATCHED',
  TREATMENT_COMPLETED: 'TREATMENT_COMPLETED'
};

exports.TherapyRematchReason = exports.$Enums.TherapyRematchReason = {
  DISSATISFIED_WITH_MHP: 'DISSATISFIED_WITH_MHP',
  DISSATISFIED_WITH_MHP_SKILLS: 'DISSATISFIED_WITH_MHP_SKILLS',
  DISSATISFIED_WITH_MHP_BEHAVIOUR: 'DISSATISFIED_WITH_MHP_BEHAVIOUR',
  NO_PERSONAL_CONNECTION: 'NO_PERSONAL_CONNECTION',
  DISSATISFIED_WITH_EMPLOYEE: 'DISSATISFIED_WITH_EMPLOYEE',
  MHP_NOT_SUITED: 'MHP_NOT_SUITED',
  MHP_OFFBOARDED: 'MHP_OFFBOARDED',
  MHP_UNAVAILABLE: 'MHP_UNAVAILABLE',
  EMPLOYEE_CHANGED_MIND: 'EMPLOYEE_CHANGED_MIND',
  OTHER: 'OTHER'
};

exports.ResourceStatus = exports.$Enums.ResourceStatus = {
  PUBLISHED: 'PUBLISHED',
  SUGGESTED: 'SUGGESTED',
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT'
};

exports.ResourceType = exports.$Enums.ResourceType = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  ARTICLE: 'ARTICLE',
  PODCAST: 'PODCAST',
  WORKSHEET: 'WORKSHEET',
  COURSE: 'COURSE',
  TALK: 'TALK',
  ASSET: 'ASSET',
  CONTENT: 'CONTENT'
};

exports.TherapyModality = exports.$Enums.TherapyModality = {
  ACT: 'ACT',
  ACT_CBT_LONG_TERM_HEALTH_CONDITION: 'ACT_CBT_LONG_TERM_HEALTH_CONDITION',
  CAT: 'CAT',
  CBT: 'CBT',
  COACHING: 'COACHING',
  COUNSELLING: 'COUNSELLING',
  DEPRESSION_COUNSELLING: 'DEPRESSION_COUNSELLING',
  DIT: 'DIT',
  MBCT: 'MBCT',
  MBSR: 'MBSR',
  PERSON_CENTERED_COUNSELLING: 'PERSON_CENTERED_COUNSELLING',
  PSYCHODYNAMIC: 'PSYCHODYNAMIC',
  PWP: 'PWP',
  COUPLES_COUNSELLING: 'COUPLES_COUNSELLING',
  PROFESSIONAL_COACHING: 'PROFESSIONAL_COACHING'
};

exports.ResourceArea = exports.$Enums.ResourceArea = {
  FITNESS: 'FITNESS',
  FOCUS: 'FOCUS',
  LEARN: 'LEARN',
  LISTEN: 'LISTEN',
  MANAGE: 'MANAGE',
  MEDITATION: 'MEDITATION',
  SLEEP: 'SLEEP',
  YOGA: 'YOGA'
};

exports.ResourceSubArea = exports.$Enums.ResourceSubArea = {
  BREATHWORK: 'BREATHWORK',
  ENERGISING_FOCUS: 'ENERGISING_FOCUS',
  LETTING_GO_OF_STRESS: 'LETTING_GO_OF_STRESS',
  MEDITATION_FOR_BEGINNERS: 'MEDITATION_FOR_BEGINNERS',
  QUICK_FITNESS_ROUTINES_FOR_EVERYDAY: 'QUICK_FITNESS_ROUTINES_FOR_EVERYDAY',
  RELAXATION: 'RELAXATION',
  SLEEP: 'SLEEP',
  YOGA_FOR_OFFICE_WORKERS: 'YOGA_FOR_OFFICE_WORKERS',
  BEDTIME_STORIES: 'BEDTIME_STORIES',
  BEGINNING_MEDITATION: 'BEGINNING_MEDITATION',
  FAST_EXERCISES: 'FAST_EXERCISES',
  FAST_MEDITATIONS: 'FAST_MEDITATIONS',
  FITNESS: 'FITNESS',
  INTRO_TO_MENTAL_HEALTH: 'INTRO_TO_MENTAL_HEALTH',
  QUICK_FOCUS_RESET: 'QUICK_FOCUS_RESET',
  SOUNDSCAPE: 'SOUNDSCAPE',
  WIND_DOWN: 'WIND_DOWN',
  WORK: 'WORK',
  YOGA: 'YOGA'
};

exports.ResourceConsumptionSource = exports.$Enums.ResourceConsumptionSource = {
  LIBRARY: 'LIBRARY',
  SELF_GUIDED: 'SELF_GUIDED'
};

exports.ResourceFavouriteStatus = exports.$Enums.ResourceFavouriteStatus = {
  FAVOURITE: 'FAVOURITE',
  UNFAVOURITE: 'UNFAVOURITE'
};

exports.ThumbsFeedback = exports.$Enums.ThumbsFeedback = {
  THUMBS_UP: 'THUMBS_UP',
  THUMBS_DOWN: 'THUMBS_DOWN'
};

exports.ExerciseType = exports.$Enums.ExerciseType = {
  ONBOARDING: 'ONBOARDING',
  IDENTIFY_VALUES: 'IDENTIFY_VALUES',
  REFLECT_VALUES: 'REFLECT_VALUES',
  RISK_ASSESSMENT: 'RISK_ASSESSMENT',
  BREATHING_MINDFULNESS: 'BREATHING_MINDFULNESS',
  PLANNING_ACTION: 'PLANNING_ACTION',
  BODY_SCAN: 'BODY_SCAN',
  HOOK_DIARY: 'HOOK_DIARY',
  ACT_MATRIX: 'ACT_MATRIX',
  WRAP_UP: 'WRAP_UP'
};

exports.ExerciseAssignmentStatus = exports.$Enums.ExerciseAssignmentStatus = {
  ASSIGNED: 'ASSIGNED',
  STARTED: 'STARTED',
  SKIPPED: 'SKIPPED',
  COMPLETED: 'COMPLETED'
};

exports.ExerciseAssignmentExecutionMode = exports.$Enums.ExerciseAssignmentExecutionMode = {
  PDF: 'PDF',
  AI: 'AI'
};

exports.PreferenceType = exports.$Enums.PreferenceType = {
  PREFERRED: 'PREFERRED',
  EXCLUDED: 'EXCLUDED',
  EXCLUSIVE_TO: 'EXCLUSIVE_TO'
};

exports.Platform = exports.$Enums.Platform = {
  IOS: 'IOS',
  ANDROID: 'ANDROID'
};

exports.Prisma.ModelName = {
  user: 'user',
  insuranceInformation: 'insuranceInformation',
  insuranceClaim: 'insuranceClaim',
  userImpersonationLog: 'userImpersonationLog',
  userSettings: 'userSettings',
  userSettingsHistory: 'userSettingsHistory',
  guestsToUsers: 'guestsToUsers',
  contactDetails: 'contactDetails',
  clinicalProfile: 'clinicalProfile',
  clinicalModalityExpertise: 'clinicalModalityExpertise',
  clinicalProblemExpertise: 'clinicalProblemExpertise',
  clinicalExperienceWith: 'clinicalExperienceWith',
  service: 'service',
  schedulerInformation: 'schedulerInformation',
  userStrikes: 'userStrikes',
  chat: 'chat',
  allowlist: 'allowlist',
  organisation: 'organisation',
  organisationTeams: 'organisationTeams',
  organisationSlackIntegration: 'organisationSlackIntegration',
  organisationPlan: 'organisationPlan',
  organisationSettings: 'organisationSettings',
  organisationChangeHistory: 'organisationChangeHistory',
  organisationSettingsHistory: 'organisationSettingsHistory',
  invitation: 'invitation',
  letterToProfessional: 'letterToProfessional',
  payment: 'payment',
  session: 'session',
  groupSession: 'groupSession',
  sessionSettings: 'sessionSettings',
  groupSessionHosts: 'groupSessionHosts',
  groupSessionParticipants: 'groupSessionParticipants',
  externalGroupSessionParticipants: 'externalGroupSessionParticipants',
  appointment: 'appointment',
  sessionReminders: 'sessionReminders',
  sessionCancellation: 'sessionCancellation',
  survey: 'survey',
  surveyQuestion: 'surveyQuestion',
  clinicalQuestionnaire: 'clinicalQuestionnaire',
  workshop: 'workshop',
  workshopHosts: 'workshopHosts',
  workshopRequest: 'workshopRequest',
  workshopRequestParticipants: 'workshopRequestParticipants',
  workshopWaitingList: 'workshopWaitingList',
  workshopAccessList: 'workshopAccessList',
  workshopTheme: 'workshopTheme',
  note: 'note',
  noteLog: 'noteLog',
  sessionRiskManagement: 'sessionRiskManagement',
  therapy: 'therapy',
  therapyStatusHistory: 'therapyStatusHistory',
  resource: 'resource',
  resourceHost: 'resourceHost',
  resourcesHosts: 'resourcesHosts',
  resourceCourse: 'resourceCourse',
  sharedResource: 'sharedResource',
  resourceTheme: 'resourceTheme',
  resourceConsumption: 'resourceConsumption',
  resourceFavourite: 'resourceFavourite',
  subArea: 'subArea',
  rating: 'rating',
  customCareRecordEvent: 'customCareRecordEvent',
  deviceToken: 'deviceToken',
  supervisionSubmission: 'supervisionSubmission',
  carePlanReminders: 'carePlanReminders',
  recommendedResourceSet: 'recommendedResourceSet',
  recommendedResourceItem: 'recommendedResourceItem',
  exercise: 'exercise',
  exerciseAssignment: 'exerciseAssignment',
  professionalOrganisationPreference: 'professionalOrganisationPreference',
  minimumSupportedVersion: 'minimumSupportedVersion',
  organisationGroup: 'organisationGroup'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
